const expressions = {
  email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
  letters: /^[a-zA-ZÀ-ÿ\s]{1,40}$/,
  telephone: /^\d{7,14}$/,
};

export { expressions };
